import { Container } from "@mui/material";
import { useCallback } from "react";
import { useParams } from "react-router-dom";
import GoodProfileForm from "../../../components/commodity-management/GoodProfileForm";
import HeaderTitle from "../../../components/common/HeaderTitle";
import { GoodProfile } from "../../../graphql/generated";
import { useNavigationOptions } from "../../LayoutRoutes";
import { useTranslation } from "react-i18next";

function EditGoodProfile() {
  const { t } = useTranslation("assets");
  const { id } = useParams();
  const { setNavigationOptions } = useNavigationOptions();
  const onLoad = useCallback(
    (goodProfile: Pick<GoodProfile, "code">) => {
      setNavigationOptions({
        title: (
          <HeaderTitle
            label={t("commodity.edit", "Edit Commodity")}
            suffix={goodProfile?.code || ""}
          />
        ),
        showBackIcon: true,
      });
    },
    [setNavigationOptions, t]
  );
  if (!id) {
    return null;
  }
  return (
    <Container>
      <GoodProfileForm goodProfileId={id} onLoad={onLoad} />
    </Container>
  );
}

export default EditGoodProfile;
